import type { FC } from 'react'

import { Input } from '@skytech/ui'
import type { FieldProps } from 'formik'
import { Field } from 'formik'

import Text from '@/app/translations/Text'

import './SimCard.styles.scss'

const SimCard: FC<{ isNewNumber: boolean | string; isEditable: boolean }> = ({
  isNewNumber,
  isEditable,
}) => {
  if (isNewNumber === '') return null

  return (
    <section className="sim-card">
      <h3>
        <Text id="SIM-kort" />
      </h3>

      <div className="flex">
        <Field name="simName">
          {({ field, meta }: FieldProps) => (
            <Input
              id="simName"
              marginBottom={16}
              label={
                <Text id="Navn på mottaker av SIM (Vi sender simkort til din privat adresse)" />
              }
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              autoComplete="name"
              {...field}
            />
          )}
        </Field>
      </div>

      <div className="address">
        <Field name="simAdr">
          {({ field, meta }: FieldProps) => (
            <Input
              isFullWidth
              id="simAdr"
              label={<Text id="Din privatadresse" />}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              autoComplete="street-address"
              {...field}
            />
          )}
        </Field>

        <Field name="simZip">
          {({ field, meta }: FieldProps) => (
            <Input
              isFullWidth
              id="simZip"
              label={<Text id="Postnummer" />}
              maxLength={10}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              autoComplete="postal-code"
              {...field}
            />
          )}
        </Field>

        <Field name="simCity">
          {({ field, meta }: FieldProps) => (
            <Input
              isFullWidth
              id="simCity"
              label={<Text id="Poststed" />}
              error={meta.error}
              touched={meta.touched}
              isDisabled={!isEditable}
              autoComplete="address-level2"
              {...field}
            />
          )}
        </Field>
      </div>
    </section>
  )
}

export default SimCard
